function genHistory () {
  return function (value) {
    this.$store.dispatch('Dialogs/setHistory', value)
  }
}
function genApproveHistory () {
  return function (value) {
    this.$store.dispatch('Dialogs/setApproveHistory', value)
  }
}
function genApproval (a) {
  if (a === 1) {
    return function (value) {
      this.$store.dispatch('Dialogs/setApprovalStatus', value)
    }
  } else if (a === 2) {
    return function (value) {
      this.$store.dispatch('Dialogs/setApprovalData', value)
    }
  } else if (a === 3) {
    return function (value) {
      this.$store.dispatch('Dialogs/setApprovalAction', value)
    }
  }
}
function genApprovalN () {
  return function (value) {
    this.$store.dispatch('Dialogs/setApprovalNotification', value)
  }
}

const Dialogs = {
  install (Vue, options) {
    Vue.prototype.$showHistory = genHistory()
    Vue.prototype.$closeHistory = genHistory()
    Vue.prototype.$showApproveH = genApproveHistory()
    Vue.prototype.$showApprovalStatus = genApproval(1)
    Vue.prototype.$showApprovalData = genApproval(2)
    Vue.prototype.$showApprovalAction = genApproval(3)
    Vue.prototype.$setApprovalNotification = genApprovalN()
  }
}

export default Dialogs



// WEBPACK FOOTER //
// ./src/helpers/dialogs.js